import { clx } from '@medusajs/ui';
import { Drawer } from '@medusajs/ui';
import { useCallback, useEffect, useState } from 'react';

import { AppLink } from '@adapters';
import SearchBox from '@modules/search/components/search-box';

import { MobileSearchContext, type MobileSearchContextType } from './context';

export { useMobileSearch } from './context';

// Mock data for top searches - will be replaced with API call
const mockTopSearches = [
  { id: '1', keyword: '益生菌', link: '/search?q=益生菌' },
  { id: '2', keyword: '維他命', link: '/search?q=維他命' },
  { id: '3', keyword: '魚油', link: '/search?q=魚油' },
  { id: '4', keyword: '葉黃素', link: '/search?q=葉黃素' },
];

export const MobileSearchProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [topSearches, setTopSearches] = useState<
    { id: string; keyword: string; link: string }[]
  >([]);

  // Mock fetch - will be replaced with actual API call using useQuery
  const fetchTopSearches = useCallback(async () => {
    // TODO: Replace with actual API call
    // const res = await api.get('/api/cms/top-search');
    setTopSearches(mockTopSearches);
  }, []);

  const toggleDrawer = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <MobileSearchContext.Provider
      value={{
        isOpen,
        toggleDrawer,
      }}
    >
      <MobileSearch
        isOpen={isOpen}
        topSearches={topSearches}
        fetchTopSearches={fetchTopSearches}
        toggleDrawer={toggleDrawer}
      />
      {children}
    </MobileSearchContext.Provider>
  );
};

const MobileSearch = ({
  isOpen,
  topSearches,
  fetchTopSearches,
  toggleDrawer,
}: MobileSearchContextType) => {
  useEffect(() => {
    if (isOpen) {
      fetchTopSearches();
    }
  }, [isOpen, fetchTopSearches]);

  useEffect(() => {
    fetchTopSearches();
  }, [fetchTopSearches]);

  return (
    <Drawer open={isOpen} onOpenChange={toggleDrawer}>
      <Drawer.Content className="mobile-search" data-testid="mobile-search-drawer">
        <Drawer.Header>
          <Drawer.Title></Drawer.Title>
        </Drawer.Header>
        <Drawer.Body className="overflow-auto">
          <SearchBox placeholder="請輸入商品、國際條碼或是成分搜尋" />
          <div className="text-black-10 mt-6 whitespace-nowrap">熱門搜尋</div>
          {topSearches.map((search) => (
            <AppLink
              onClick={toggleDrawer}
              className={clx(
                'tab-pill border-white-20 bg-white-20 text-black-50 hover:border-primary-10 hover:text-primary-50 active:bg-primary-10 mx-2 mt-6 inline-block cursor-pointer whitespace-nowrap rounded-full border px-3 py-1 transition-all'
              )}
              key={search.id}
              href={search.link}
            >
              {search.keyword}
            </AppLink>
          ))}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer>
  );
};
